module.exports = __webpack_public_path__ + "static/devices@2x-5a130dc0b3d95c81e737d53c67c747d0.png";